import React from 'react'
import { useIntl } from 'react-intl'
import { useMarket } from 'src/hooks/useMarket'
import styles from './styles.module.css'
import cn from 'classnames'

const BookingCodesContent = (key: string) => {
  const intl = useIntl()
  const { helpCenterUrl } = useMarket()

  return (
    <React.Fragment key={key}>
      <h4 className={cn(styles.title, styles.sticky)}>
        {intl.formatMessage({ id: 'booking-codes.title' })}
      </h4>
      <p className={styles.description}>{intl.formatMessage({ id: 'booking-codes.body-1' })}</p>
      <ol className={styles.description}>
        <li>
          <span className={styles.strong}>{intl.formatMessage({ id: 'voucher.number' })}:</span>{' '}
          {intl.formatMessage({ id: 'booking-codes.voucher-number-body' })}
        </li>
        <li>
          <span className={styles.strong}>{intl.formatMessage({ id: 'global.pin_code' })}:</span>{' '}
          {intl.formatMessage({ id: 'booking-codes.security-code-body' })}
        </li>
      </ol>
      <p className={styles.description}>
        {intl.formatMessage(
          { id: 'booking-codes.body-2' },
          {
            helpCenter: (
              <a href={helpCenterUrl} target="_blank" rel="noopener noreferrer">
                Help Center
              </a>
            ),
          }
        )}
      </p>
      <p className={styles.description}>{intl.formatMessage({ id: 'booking-codes.body-3' })}</p>
    </React.Fragment>
  )
}

export default BookingCodesContent
